"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/AuthFrame.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _responsive = require('web/services/responsive');
var _urls = require('web/services/urls');
var _icons = require('./icons');

// The phone band's slot for a step's Back button. A button rendered there
// (through a portal) is in the band's DOM, so it comes before the sheet's
// fields in tab order, as it does on screen.
 const AuthFrameBackSlot = _react.createContext(null); exports.AuthFrameBackSlot = AuthFrameBackSlot

const PHONE_QUERY = `(max-width: ${_responsive.PaneOverlayMaxWidth - 1}px)`

// True below the phone breakpoint (the same one the frame's CSS uses).
 const useIsPhoneFrame = () => {
  const query = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(PHONE_QUERY)
    : null
  const [isPhone, setIsPhone] = _react.useState.call(void 0, () => !!_optionalChain([query, 'optionalAccess', _ => _.matches]))
  _react.useEffect.call(void 0, () => {
    if (!query) return undefined
    const onChange = () => setIsPhone(query.matches)
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [query])
  return isPhone
}; exports.useIsPhoneFrame = useIsPhoneFrame

// Card widths from the approved sign-up annotations; `login` is sign-in's 420.
























// The signed-out page: the care doodle with a white card on it. Below the
// phone breakpoint the doodle becomes a band and the card a white sheet.
const AuthFrame = ({
  align = 'center',
  size = 'login',
  progress,
  phoneProgress,
  below,
  className,
  cardClassName,
  scrollKey,
  children,
}) => {
  const frameRef = _react.useRef(null)
  const currentYear = new Date().getFullYear()
  // The desktop app opens the homepage in the browser, not in its own window.
  const homeTarget = typeof window !== 'undefined' && window.ELECTRON ? '_blank' : '_self'
  const [backSlot, setBackSlot] = _react.useState(null)
  _react.useEffect.call(void 0, () => {
    const frame = frameRef.current
    if (frame) frame.scrollTop = 0
  }, [scrollKey])

  return (
    _react2.default.createElement(exports.AuthFrameBackSlot.Provider, { value: backSlot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
      , _react2.default.createElement('div', { ref: frameRef, className: _classBuilder2.default.call(void 0, 'auth-frame', `auth-frame--${align}`, className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
        , _react2.default.createElement('div', { className: "auth-frame--page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
          , _react2.default.createElement('div', { className: "auth-frame--band", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
            , _react2.default.createElement('header', { className: "auth-frame--topbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
              , _react2.default.createElement('a', {
                href: _urls.homepageUrl,
                target: homeTarget,
                className: "auth-frame--logo",
                'aria-label': "BloomText", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
              )
              , _react2.default.createElement('a', {
                href: _urls.supportUrl,
                target: "_blank",
                rel: "noreferrer",
                className: "auth-frame--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
, "Need help?"

                , _react2.default.createElement(_icons.ExternalLinkIcon, { size: 18, className: "auth-frame--help-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}} )
              )
            )
            , _react2.default.createElement('div', { className: "auth-frame--phone-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
              , _react2.default.createElement('div', { className: "auth-frame--back-slot", ref: setBackSlot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}} )
              ,  phoneProgress && (
                _react2.default.createElement('div', { className: "auth-frame--phone-progress", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}},  phoneProgress )
              )
            )
          )
          ,  progress && _react2.default.createElement('div', { className: "auth-frame--progress", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}},  progress ) 
          , _react2.default.createElement('main', { className: "auth-frame--main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
            , _react2.default.createElement('div', { className: "auth-frame--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
              , _react2.default.createElement('div', {
                className: _classBuilder2.default.call(void 0, 
                  'auth-frame--card',
                  `auth-frame--card--${size}`,
                  cardClassName,
                ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}

                ,  children 
              )
              ,  below && _react2.default.createElement('div', { className: "auth-frame--below", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}},  below ) 
            )
            , _react2.default.createElement('footer', { className: "auth-frame--footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}, "© "
               ,  currentYear , " BloomAPI Inc."
            )
          )
        )
      )
    )
  )
}

exports. default = AuthFrame
